import React from 'react';
import { Container } from 'react-bootstrap';
import './NotFound.css';

export default function NotFound() {
  return (
    <Container fluid="sm">
      <div className="NotFound">
        <h3>Sorry, page not found.</h3>
      </div>
    </Container>
  );
}
